// extracted by mini-css-extract-plugin
export default {"TodoList":"TodoList_TodoList__Hz2Gt"};